var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.27271,
    width: 8.18182,
    height: 10.9091,
    rx: 1,
    fill: "#28262C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0032,
    y: 0.814117,
    width: 6.72078,
    height: 9.28087,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 7.09091,
    width: 8.18182,
    height: 10.9091,
    rx: 1,
    fill: "#28262C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.73053,
    y: 7.90503,
    width: 6.72078,
    height: 9.28087,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 6,
    height: 8.18182,
    rx: 1,
    transform: "rotate(-90 0 6)",
    fill: "#28262C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.27271,
    y: 18,
    width: 6,
    height: 8.18182,
    rx: 1,
    transform: "rotate(-90 9.27271 18)",
    fill: "#28262C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboards);
export default __webpack_public_path__ + "static/media/dashboards.4233ca7a8d2ec7873cea21d8bfecea60.svg";
export { ForwardRef as ReactComponent };